import React, { useContext, useState } from "react";
import Slider from "react-slick";
import { EyeHiddenIcon, EyeShowIcon } from "~/assets/svg/InterfaceIcon";
import { Case, If } from "~/common/components/If";
import TabMenu from "~/common/components/TabMenu";
import darkProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { AppManContext } from "../../../RoundManContext";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const confirmSettings = {
	arrows: true,
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 11,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 8,
			},
		},
	],
};

const ProSixFinalCheck = () => {
	const { t } = useTranslation();
	const [currentSetupTab, setCurrentSetupTab] = useState("judge");
	const [pwShow, setPwShow] = useState(false);

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	const {
		roundData,
		addProSteps,
		setAddProSteps,
		resultFromProOne,
		resultFromProTwo,
		resultFromProThree,
		additionOutSourcing,
		resultFromProFive,
		finalAdditionSubmit,
		notiCheck,
	} = useContext(AppManContext);

	const applyCompany = roundData?.applyCompany || [];
	const selectedCompList =
		applyCompany.filter((d) => resultFromProOne.find((c) => c === d.stIdx)) || [];

	const attendJudge = resultFromProThree.filter((d) => d.role === "심사참여") || [];
	const watchJudge = resultFromProThree.filter((d) => d.role === "심사관망") || [];

	// const [showFinalCheck, FinalCheck] = useAlert();

	const tabMenuSetupList = [
		{
			id: "judge",
			title: `${t(
				"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFive.tabMenuSetupList.judge"
			)}(${attendJudge.length})`,
		},
		{
			id: "watch",
			title: `${t(
				"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFive.tabMenuSetupList.watch"
			)}(${watchJudge.length})`,
		},
		{
			id: "external",
			title: `${t(
				"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFive.tabMenuSetupList.external"
			)}(${additionOutSourcing?.length || 0})`,
		},
	];

	const finalApprove = () => {
		finalAdditionSubmit();
		// showFinalCheck().then(() => setAddJudgeModal(false))
	};

	const moveToPrevStep = () => {
		setAddProSteps(addProSteps - 1);
	};

	return (
		<>
			<div className="modal-content setupConfirm">
				<div className="evaluate-setup-header">
					<p className="main-desc">
						{t(
							"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.title"
						)}
					</p>
				</div>
				<div className="c__card setup-card">
					<div className="setup-wrap date">
						<h4 className="setup-title">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.dateTitle"
							)}
						</h4>
						<div className="notice-content">
							<p>{`${resultFromProTwo.startDate.toLocaleString()}   ~   ${resultFromProTwo.endDate.toLocaleString()}`}</p>
						</div>
					</div>
					<div className="setup-wrap company">
						<h4 className="setup-title">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.companyTitle"
							)}
							({selectedCompList.length ?? 0})
						</h4>
						<div className="scroll-wrap">
							<ul className="company-group">
								{selectedCompList.map((d, idx) => (
									<li key={idx}>{d.companyName}</li>
								))}
							</ul>
						</div>
					</div>
					<div className="setup-wrap judge">
						<TabMenu
							tabItem={tabMenuSetupList}
							currentTab={currentSetupTab}
							setCurrentTab={setCurrentSetupTab}
						/>
						<If condition={currentSetupTab}>
							<Case condition={"judge"}>
								<Slider {...confirmSettings} className="vc-confirm-carousel">
									{attendJudge.map((d, idx) => (
										<div className="member-box" key={idx}>
											<img
												src={
													d.img ||
													(theme === "dark"
														? darkProfileImg
														: lightProfileImg)
												}
												alt={t(
													"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.imageAlt"
												)}
											/>
											<p className="judge-name">{d.name}</p>
										</div>
									))}
								</Slider>
							</Case>
							<Case condition={"watch"}>
								<Slider {...confirmSettings} className="vc-confirm-carousel">
									{watchJudge.map((d, idx) => (
										<div className="member-box" key={idx}>
											<img
												src={
													d.img ||
													(theme === "dark"
														? darkProfileImg
														: lightProfileImg)
												}
												alt={t(
													"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.imageAlt"
												)}
											/>
											<p className="judge-name">{d.name}</p>
										</div>
									))}
								</Slider>
							</Case>
							<Case condition={"external"}>
								<div className="external-vc-list">
									<ul className="scroll-wrap">
										<li className="thead">
											<div className="td-num">No</div>
											<div className="td-name">
												{t(
													"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.externalTable.tableHead01"
												)}
											</div>
											<div className="td-id">
												{t(
													"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.externalTable.tableHead02"
												)}
											</div>
											<div className="td-pwd">
												{t(
													"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.externalTable.tableHead03"
												)}
											</div>
											<div className="td-mail">
												{t(
													"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.externalTable.tableHead04"
												)}
											</div>
										</li>
										{additionOutSourcing.map((d, idx) => (
											<li className="passwordShow hidden" key={idx}>
												<div className="td-num">{idx + 1}</div>
												<div className="td-name">{d.name}</div>
												<div className="td-id">{d.id}</div>
												<div className="td-pwd">
													{pwShow ? (
														<p>
															&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
														</p>
													) : (
														<p>{d.pw}</p>
													)}
												</div>
												<div className="td-mail">{d.email}</div>
												<button
													type="button"
													className="td-toggle"
													onClick={() => setPwShow(!pwShow)}
												>
													{pwShow ? <EyeHiddenIcon /> : <EyeShowIcon />}
												</button>
											</li>
										))}
									</ul>
								</div>
								<p className="external-vc-notice">
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.notice"
									)}
								</p>
							</Case>
						</If>
					</div>
					<div className="setup-wrap category">
						<h4 className="setup-title">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.categoryTitle"
							)}
						</h4>
						<ul className="category-table">
							<li className="single-category table-head">
								<p className="main-category">
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.categoryTable.tableHead01"
									)}
								</p>
								<p className="sub-category">
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.categoryTable.tableHead02"
									)}
								</p>
								<span className="weight">
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.categoryTable.tableHead03"
									)}
								</span>
							</li>
							{resultFromProTwo.settingData.Category.map((d, idx) => {
								return (
									<li className="single-category" key={idx}>
										<p className="main-category">{d.title}</p>
										<p className="sub-category">
											{d.Item?.map((d, idx) => (
												<p key={idx}>{d.content}</p>
											))}
										</p>
										<span className="weight">
											<p className="percent-box">{`${d.weight}%`}</p>
										</span>
									</li>
								);
							})}
						</ul>
					</div>
					{notiCheck && (
						<div className="setup-wrap notice">
							<h4 className="setup-title">
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.noticeTitle"
								)}
							</h4>
							<div className="scroll-wrap">
								<div className="notice-content">
									<p className={"notice-title"}>{resultFromProFive.title}</p>
									<diV>
										{resultFromProFive?.content?.split("\n").map((text) => {
											return (
												<span>
													{text}
													<br />
												</span>
											);
										})}
									</diV>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="gray" onClick={moveToPrevStep}>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.prev")}
				</button>
				{/* <button
					type="button"
					className="btn__solid"
					color="primary"
					// onClick={showJudgeDateAlert}
					// onClick={showConfirmAlert}
					// onClick={showExternalAlert}
				>
					다음
				</button> */}
				<button type="button" className="btn__solid" color="primary" onClick={finalApprove}>
					{t(
						"pages.round.RoundManage.modal.additionalRound.steps.ProSixFinalCheck.confirm"
					)}
				</button>
			</div>

			{/*<FinalCheck*/}
			{/*	message="추가 심사를 이대로 진행 하시겠습니까?"*/}
			{/*	type="success"*/}
			{/*	reject="아니요"*/}
			{/*	confirm="예"*/}
			{/*/>*/}
		</>
	);
};

export default ProSixFinalCheck;
